// Libs
import React, { Component } from 'react'
import _ from 'lodash'
import { CheckCircle, Clock, Archive } from 'react-feather'

// CSS
import './styles.scss'

// Components/Containers
import DashboardPill from '../DashboardPill'
import DashboardTitle from '../DashboardTitle'

// Normalize
import { normalize } from '../../constants'

class DashboardJourney extends Component {
  render() {
    const { data } = this.props

    const total = Math.round(data['invite_protocol'])
    const invite_invite_accept = Math.round(data['invite_invite_accept'])
    const invite_accept_first_offer = Math.round(data['invite_accept_first_offer'])
    const first_offer_accept = Math.round(data['first_offer_accept'])
    const accept_first_minute = Math.round(data['accept_first_minute'])
    const first_minute_last_minute = Math.round(data['first_minute_last_minute'])
    const last_minute_protocol = total - (invite_invite_accept + invite_accept_first_offer + first_offer_accept + accept_first_minute + first_minute_last_minute)
    const archived_average_time = Math.round(data['archived_average_time'])

    const invite_invite_accept_width = Math.round(invite_invite_accept * 100 / total)
    const invite_accept_first_offer_width = Math.round(invite_accept_first_offer * 100 / total)
    const first_offer_accept_width = Math.round(first_offer_accept * 100 / total)
    const accept_first_minute_width = Math.round(accept_first_minute * 100 / total)
    const first_minute_last_minute_width = Math.round(first_minute_last_minute * 100 / total)
    const last_minute_protocol_width = 100 - (invite_invite_accept_width + invite_accept_first_offer_width + first_offer_accept_width + accept_first_minute_width + first_minute_last_minute_width)

    // Set minimum
    let widths = [
      { id: 0, title: 'invite_invite_accept_width', value: invite_invite_accept_width },
      { id: 1, title: 'invite_accept_first_offer_width', value: invite_accept_first_offer_width },
      { id: 2, title: 'first_offer_accept_width', value: first_offer_accept_width },
      { id: 3, title: 'accept_first_minute_width', value: accept_first_minute_width },
      { id: 4, title: 'first_minute_last_minute_width', value: first_minute_last_minute_width },
      { id: 5, title: 'last_minute_protocol_width', value: last_minute_protocol_width }
    ]

    widths = _.orderBy(widths, ['value'], ['asc'])

    let diff = 0
    let sumValue = 0
    let counter = 0

    widths = widths.map((width, idx) => {
      const minimum = 11
      let value = width.value

      if (value < minimum) {
        diff += minimum - width.value
        counter++
        value = minimum
      } else {
        value -= Math.round(diff / (widths.length - counter))

        if (value < minimum) {
          diff += minimum - width.value
          counter++
          value = minimum
        }

        if (widths.length === idx + 1) {
          value = 100 - sumValue
        }
      }

      sumValue += value

      return { ...width, value }
    })

    widths = _.orderBy(widths, ['id'], ['asc'])

    return (
      <div className="dashboard-journey">
        <div className="dashboard-journey__title">
          <DashboardTitle title="Jornada Ao Sucesso" subTitle="tempo entre acontecimentos" />
          <div className="dashboard-journey__total">
            <p>TOTAL:</p>
            <CheckCircle />
            <p title='Desconsiderando tempo arquivado'>{Math.round(total / 24) - archived_average_time} dias</p>
            <Archive />
            <p title='Tempo do caso arquivado'>{archived_average_time} dias</p>
            <Clock color={'black'} />
            <p title='Considerando tempo arquivado'>{Math.round(total / 24)} dias</p>
          </div>
        </div>
        <div className="dashboard-journey__body">
          <div className="dashboard-journey__wrapper">
            <div
              style={{ width: `${widths[0].value}%` }}
              className="dashboard-journey__metric">
              <span></span>
              <div><p>{invite_invite_accept}h</p></div>
              <div><p>Envio Convite</p></div>
            </div>
            <div
              style={{ width: `${widths[1].value}%` }}
              className="dashboard-journey__metric">
              <span></span>
              <div><p>{invite_accept_first_offer}h</p></div>
              <div><p>Aceite Convite</p></div>
            </div>
            <div
              style={{ width: `${widths[2].value}%` }}
              className="dashboard-journey__metric">
              <span></span>
              <div><p>{first_offer_accept}h</p></div>
              <div><p>Primeira Proposta</p></div>
            </div>
            <div
              style={{ width: `${widths[3].value}%` }}
              className="dashboard-journey__metric">
              <span></span>
              <div><p>{accept_first_minute}h</p></div>
              <div><p>Acordo</p></div>
            </div>
            <div
              style={{ width: `${widths[4].value}%` }}
              className="dashboard-journey__metric">
              <span></span>
              <div><p>{first_minute_last_minute}h</p></div>
              <div><p>Envio Minuta</p></div>
            </div>
            <div
              style={{ width: `${widths[5].value}%` }}
              className="dashboard-journey__metric">
              <span></span>
              <span></span>
              <div><p>{last_minute_protocol}h</p></div>
              <div><p>Assinatura</p></div>
              <div><p>Protocolo</p></div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

export default DashboardJourney
